import { render, staticRenderFns } from "./o-services-modal.vue?vue&type=template&id=52a4489d&"
import script from "./o-services-modal.vue?vue&type=script&lang=js&"
export * from "./o-services-modal.vue?vue&type=script&lang=js&"
import style0 from "./o-services-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports